import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { map, Observable } from "rxjs";
import { IEstimate } from "./models/estimate.model";
import { ICustomerRma } from "./models/customer-return.model";
import { ICreditMemo } from "./models/credit-memo.model";
import { IReceivePayment } from "src/app/modules/shared/components/receive-payments/model/receive-payment.model";

@Injectable()
export class SalesOrderService {

    appUrl = "";
    localAppUrl = "";
    coreUrl = "";
    private headers = new HttpHeaders({ "Content-Type": "application/json" });
    constructor(private http: HttpClient) {
        this.appUrl = environment.apiUrl + "Cases/";
        this.coreUrl = environment.coreUrl;
        this.localAppUrl = environment.localApiUrl;
    }

    getLoggedUser(userId) {
        return this.http
            .get<any>(this.localAppUrl + "users/" + userId)
            .toPromise()
            .then((res) => res);
    }

    updateUser(user) {
        return this.http
            .put(this.localAppUrl + "users/" + user.id, user, {
                headers: this.headers,
            })
            .toPromise()
            .then(() => user);
    }
    getAllStages() {
        return this.http
            .get<any>(this.localAppUrl + "allOrderStages")
            .toPromise()
            .then((res) => res);
    }

    checkClearBitData(email) {
        return this.http
            .get<any>(environment.clearBitAPIURL + email, {
                headers: new HttpHeaders({
                    Authorization: environment.clearBitAPIKey,
                }),
            })
            .toPromise()
            .then((res) => res);
    }

    updateCaseStage(caseStage) {
        let url =
            this.localAppUrl +
            "CaseStages?id=" +
            caseStage.id +
            "&caseStageId=" +
            caseStage.caseStageId;
        return this.http
            .put<any>(url, {
                headers: this.headers,
            })
            .toPromise()
            .then((res) => res);
    }

    getAllContactSource(companyID: number) {
        return this.http
            .get<any>(this.coreUrl + "Source/" + "?organizationId=" + companyID)
            .toPromise()
            .then((res) => res);
    }
    getAllAccounts() {
        return this.http
            .get<any>(this.localAppUrl + "allAccounts")
            .toPromise()
            .then((res) => res);
    }
    getAllCustomers() {
        return this.http
            .get<any>(this.localAppUrl + "allCustomers")
            .toPromise()
            .then((res) => res);
    }
    getAllEstimates() {
        return this.http
            .get<any>(this.localAppUrl + "allEstimates")
            .toPromise()
            .then((res) => res);
    }
    getAllInvoicing() {
        return this.http
            .get<any>(this.localAppUrl + "allInvoicing")
            .toPromise()
            .then((res) => res);
    }
    getAllCredits() {
        return this.http
            .get<any>(this.localAppUrl + "allCredits")
            .toPromise()
            .then((res) => res);
    }
    getAllOrders() {
        return this.http
            .get<any>(this.localAppUrl + "allSalesOrders")
            .toPromise()
            .then((res) => res);
    }
    getAllStatus() {
        return this.http
            .get<any>(this.localAppUrl + "allOrderStatus")
            .toPromise()
            .then((res) => res);
    }
    getAllPayments() {
        return this.http
            .get<any>(this.localAppUrl + "allBillPayments")
            .toPromise()
            .then((res) => res);
    }

    getAllOrdersChannel(name): Observable<any> {
        return this.http.get<any>(
            `${environment.configUrl}Configuration/Name?name=${name}`
        );
    }
    getAllOrdersChannel1(name) {
        return this.http
            .get<any>(`${environment.configUrl}Configuration/Name?name=${name}`)
            .toPromise()
            .then((res) => res);
    }

    getAccountChannels(name) {
        return this.http.get<any>(
            `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`
        );
    }

    getAllEstimatesByPagination(
        typeId,
        pageNo,
        pageSize,
        filters,
        searchValue,
        searchColumn,
        sortBy,
        isAscending,
        isActive,
        accChannelId
    ) {
        let params = new HttpParams();
        params = params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        params = params.append("SearchValue", searchValue);
        params = !filters ? params : params.append("filter", filters);
        params = params.append("isActive", isActive);
        params = params.append("channelId", accChannelId);
        return this.http
            .get<any>(
                `${environment.inventorySalesUrl}Estimate?PageNumber=${pageNo}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                data: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllInvoiceByPagination(
        typeId,
        pageNo,
        pageSize,
        filters,
        searchValue,
        searchColumn,
        sortBy,
        isAscending,
        isActive,
        accChannelId
    ) {
        let params = new HttpParams();
        params = params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        params = params.append("SearchValue", searchValue);
        params = !filters ? params : params.append("filter", filters);
        params = params.append("isActive", isActive);
        params = params.append("channelId", accChannelId);
        return this.http
            .get<any>(
                `${environment.inventorySalesUrl}Invoice?PageNumber=${pageNo}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllCustomerReturnsByPagination(
        typeId,
        pageNo,
        pageSize,
        filters,
        searchValue,
        searchColumn,
        sortBy,
        isAscending,
        isActive,
        accChannelId,
        isGlobalSearch = false
    ) {
        let params = new HttpParams();
        params = params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        params = params.append("SearchValue", searchValue);
        params = !filters ? params : params.append("filter", filters);
        params = params.append("isActive", isActive);
        params = params.append("channelId", accChannelId);
        params = params.append("isGlobalSearch", isGlobalSearch);

        return this.http
            .get<any>(
                `${environment.inventorySalesUrl}CustomerRma?PageNumber=${pageNo}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllCreditMemoByPagination(
        typeId,
        pageNo,
        pageSize,
        filters,
        searchValue,
        searchColumn,
        sortBy,
        isAscending,
        isActive,
        accChannelId
    ) {
        let params = new HttpParams();
        params = params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        params = params.append("SearchValue", searchValue);
        params = !filters ? params : params.append("filter", filters);
        params = params.append("isActive", isActive);
        params = params.append("channelId", accChannelId);
        return this.http
            .get<any>(
                `${environment.inventorySalesUrl}CreditMemo?PageNumber=${pageNo}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }
    getAllSalesReceiptsPagination(requestModel) {
        return this.http.post(`${environment.inventorySalesUrl}SalesReceipt`, requestModel);
    }
    getAllSalesReceiptsPagination1(requestModel) {
        return this.http.post(`${environment.inventorySalesUrl}SalesReceipt/GroupedPageList`, requestModel);
    }


    getAllSalesOrderByPagination(
        typeId,
        pageNo,
        pageSize,
        filters,
        searchValue,
        searchColumn,
        sortBy,
        isAscending,
        isActive,
        accChannelId = 0
    ) {
        let params = new HttpParams();
        params = params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        params = params.append("SearchValue", searchValue);
        params = !filters ? params : params.append("filter", filters);
        params = params.append("isActive", isActive);
        params = params.append("channelId", accChannelId);
        return this.http
            .get<any>(
                `${environment.inventorySalesUrl}SalesOrder?PageNumber=${pageNo}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    addEstimate(estimateObj: IEstimate, isBaseCurrency: boolean) {
        return this.http
            .post<any>(`${environment.inventorySalesUrl}Estimate?isBaseCurrency=${isBaseCurrency}`, estimateObj)
            .toPromise()
            .then((res) => res);
    }

    addBundleProduct(c) {
        return this.http
            .post<any>(
                `${environment.inventorySalesOrderUrl}Product/AddBundleProduct`,
                c
            )
            .toPromise()
            .then((res) => res);
    }

    convertToSalesOrder(c, isBaseCurrency: boolean) {
        return this.http
            .post<any>(
                `${environment.inventorySalesUrl}SalesOrder/AddMultipleSalesOrder?isBaseCurrency=${isBaseCurrency}`,
                c
            )
            .toPromise()
            .then((res) => res);
    }

    convertToSalesOrderFromRma(salesOrder, isBaseCurrency: boolean) {
        return this.http
            .post<any>(
                `${environment.inventorySalesUrl}SalesOrder/ConvertToSalesOrderFromRma?isBaseCurrency=${isBaseCurrency}`,
                salesOrder
            )
            .toPromise()
            .then((res) => res);
    }

    createSalesOrder(c, isBaseCurrency: boolean) {
        return this.http
            .post<any>(`${environment.inventorySalesUrl}SalesOrder?isBaseCurrency=${isBaseCurrency}`, c)
            .toPromise()
            .then((res) => res);
    }

    createInvoice(c, isBaseCurrency: boolean) {
        return this.http
            .post<any>(`${environment.inventorySalesUrl}Invoice?isBaseCurrency=${isBaseCurrency}`, c)
            .toPromise()
            .then((res) => res);
    }

    createCreditMemo(creditMemo: ICreditMemo, isBaseCurrency: boolean, rmaId?, isCovertedFromRMA?) {
        let params = new HttpParams();
        params = !rmaId ? params : params.append("customerRMAId", rmaId);
        params = !isCovertedFromRMA ? params : params.append("isConvertedFromRMA", true);
        return this.http.post<any>(`${environment.inventorySalesUrl}CreditMemo?isBaseCurrency=${isBaseCurrency}`, creditMemo, { params })
            .toPromise()
            .then((res) => res);
    }

    convertToInvoice(c, isBaseCurrency: boolean) {
        return this.http
            .post<any>(
                `${environment.inventorySalesUrl}Invoice/addMultipleInvoice?isBaseCurrency=${isBaseCurrency}`,
                c
            )
            .toPromise()
            .then((res) => res);
    }

    convertToInvoiceForRma(invoiceData, isBaseCurrency: boolean) {
        return this.http
            .post<any>(
                `${environment.inventorySalesUrl}Invoice/ConvertToInvoiceFromRma?isBaseCurrency=${isBaseCurrency}`,
                invoiceData
            )
            .toPromise()
            .then((res) => res);
    }

    createReceivedPAyment(c: IReceivePayment) {
        return this.http
            .post<any>(`${environment.inventorySalesUrl}ReceivedPayment`, c)
            .toPromise()
            .then((res) => res);
    }
    updateReceivedPayment(c: IReceivePayment) {
        return this.http
            .put<any>(`${environment.inventorySalesUrl}ReceivedPayment`, c)
            .toPromise()
            .then((res) => res);
    }

    createCustomerReturn(customerReturn: ICustomerRma, isBaseCurrency: boolean) {

        const salesOrderUrl = `${environment.inventorySalesUrl}CustomerRma?isBaseCurrency=${isBaseCurrency}`;

        return this.http
            .post<any>(salesOrderUrl, customerReturn)
            .toPromise()
            .then((res) => res);
    }

    addRMALabelCharges(customerReturn: ICustomerRma) {
        const salesOrderUrl = `${environment.inventorySalesUrl}CustomerRma/AddRMALabelCharges`;
        return this.http
            .put<any>(salesOrderUrl, customerReturn)
            .toPromise()
            .then((res) => res);
    }

    updateCustomerReturn(customerReturn: ICustomerRma, isBaseCurrency: boolean) {

        const salesOrderUrl = `${environment.inventorySalesUrl}CustomerRma?isBaseCurrency=${isBaseCurrency}`;

        return this.http
            .put<any>(salesOrderUrl, customerReturn)
            .toPromise()
            .then((res) => res);
    }

    updateInvoice(c, isBaseCurrency: boolean) {
        return this.http
            .put<any>(`${environment.inventorySalesUrl}Invoice?isBaseCurrency=${isBaseCurrency}`, c)
            .toPromise()
            .then((res) => res);
    }

    updateCreditMemo(c, isBaseCurrency: boolean) {
        return this.http
            .put<any>(`${environment.inventorySalesUrl}CreditMemo?isBaseCurrency=${isBaseCurrency}`, c)
            .toPromise()
            .then((res) => res);
    }

    updateSalesOrder(c, isBaseCurrency: boolean) {
        return this.http
            .put<any>(`${environment.inventorySalesUrl}SalesOrder?isBaseCurrency=${isBaseCurrency}`, c)
            .toPromise()
            .then((res) => res);
    }

    editEstimate(estimateObj: IEstimate) {
        return this.http
            .put<any>(`${environment.inventorySalesUrl}Estimate`, estimateObj)
            .toPromise()
            .then((res) => res);
    }

    updateEstimate(estimateObj: IEstimate, isBaseCurrency: boolean) {
        return this.http
            .put<any>(`${environment.inventorySalesUrl}Estimate?isBaseCurrency=${isBaseCurrency}`, estimateObj)
            .toPromise()
            .then((res) => res);
    }

    deleteEstimate(id) {
        return this.http
            .delete<any>(`${environment.inventorySalesUrl}Estimate/${id}`)
            .toPromise()
            .then((res) => res);
    }

    voidEstimate(id) {
        return this.http
            .delete<any>(`${environment.inventorySalesUrl}Estimate/Void?estimateId=${id}`);
    }

    voidSalesOrder(id) {
        return this.http
            .delete<any>(`${environment.inventorySalesUrl}SalesOrder/Void?id=${id}`);
    }

    voidReceivedPayment(id, isVoid?) {
        const params = !isVoid ? new HttpParams().set("isVoid", "false") : new HttpParams().set("isVoid", "true");
        return this.http.delete<any>(`${environment.inventorySalesUrl}ReceivedPayment/${id}`, {
            params: params
        });
    }

    deleteSalesOrder(id) {
        return this.http
            .delete<any>(`${environment.inventorySalesUrl}SalesOrder/${id}`)
            .toPromise()
            .then((res) => res);
    }

    deleteInvoicing(id, isVoid = false) {
        const param = isVoid ? '?isVoid=true' : '';
        return this.http
            .delete<any>(`${environment.inventorySalesUrl}Invoice/${id}${param}`)
            .toPromise()
            .then((res) => res);
    }

    deleteCustomerReturn(id: number, action: string) {
        let params = new HttpParams();
        params = action == 'delete' ? params : params.append("isVoid", true);
        let deleteCustomerReturnUrl = `${environment.inventorySalesUrl}CustomerRma/${id}`;
        return this.http.delete<any>(deleteCustomerReturnUrl, { params })
            .toPromise()
            .then((res) => res);
    }

    deleteCreditMemo(id) {
        return this.http
            .delete<any>(`${environment.inventorySalesUrl}CreditMemo/${id}`)
            .toPromise()
            .then((res) => res);
    }

    getAllProductsBySearch(typeId, pageNo, pageSize, searchValue) {
        let params = new HttpParams();
        params = !searchValue ? params : params.append("search", searchValue);
        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        return this.http
            .get<any>(
                `${environment.inventorySalesOrderUrl}Product/GetProductsBySearch?typeId=${typeId}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllClasses(
        pageNo,
        pageSize,
        searchValue,
        searchColumns,
        sortBy,
        isAscending,
        filters
    ) {
        let params = new HttpParams();
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !searchValue
            ? params
            : params.append("SearchValue", searchValue);
        params = !searchColumns
            ? params
            : params.append("SearchColumns", searchColumns);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !filters ? params : params.append("filters", filters);
        return this.http
            .get<any>(
                `${environment.financeURl}Class/ClassHierarchy?PageNumber=${pageNo}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                classes: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getPaymentMethod(id: number) {
        return this.http.get<any>(`${environment.apiUrlAccount}Account/AccountPaymentMethod/${id}`);
    }

    getAllFinancialAccount(accountType, isAscending, filters) {
        let params = new HttpParams();
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !filters ? params : params.append("filter", filters);
        return this.http
            .get<any>(
                `${environment.financeURl}FinancialAccount?accountType=${accountType}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                accounts: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getEstimatesDetailsById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}Estimate/${id}`
        );
    }

    getEstimatesDetailsByNumber(no: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}Estimate/EstimateByNumber?number=${no}`
        );
    }

    getFilterData(id: Number, columnName: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CommonService/FilterData?objectNameList=${columnName}&typeId=${id}`
        );
    }

    getCreditMemoByAccount(id: Number, creditMemoId: string = null, invoiceId: number = 0, salesOrderId: number = 0, isPayment: boolean = false): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CreditMemo/CreditMemoByAccount?accountId=${id}&creditMemoId=${creditMemoId}&invoiceId=${invoiceId}&salesOrderId=${salesOrderId}&isPayment=${isPayment}`
        );
    }
    getReceivePaymentByTransaction(data: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}ReceivedPayment/ReceivedPaymentByTransaction?${data}`
        );
    }

    getInvoicesByAccount(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}Invoice/InvoicesByAccount?accountId=${id}`
        );
    }

    getAllWarehouse(
        pageNo,
        pageSize,
        filters,
        searchValue,
        searchColumn,
        sortBy,
        isAscending
    ) {
        let params = new HttpParams();
        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        params = !sortBy ? params : params.append("SortBy", sortBy);
        params = !searchColumn
            ? params
            : params.append("SearchColumns", searchColumn);
        params = !searchValue
            ? params
            : params.append("SearchValue", searchValue);
        params = !filters ? params : params.append("filter", filters);
        return this.http.get<any>(`${environment.inventoryURl}Warehouse`, {
            observe: "response",
            params,
        });
    }

    getSalesOrderDetailsById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}SalesOrder/${id}`
        );
    }

    getSalesOrderDetailsByNumber(no: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}SalesOrder/SalesOrderByNumber?number=${no}`
        );
    }

    getInvoicesBySalesOrderId(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}Invoice/InvoicesBySalesOrder?salesOrderId=${id}`
        );
    }

    getInvoiceDetailsById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}Invoice/${id}`
        );
    }

    getInvoiceDetailsByNumber(number: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}Invoice/InvoiceByNumber?number=${number}`
        );
    }

    getCustomerReturnById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CustomerRma/${id}`
        );
    }

    getCustomerReturnByNumber(no: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CustomerRma/CustomerRmaByNumber?number=${no}`
        );
    }

    getCreditMemoById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CreditMemo/${id}`
        );
    }

    getCreditMemoByNumber(no: string): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CreditMemo/CreditMemoByNumber?number=${no}`
        );
    }

    getCreditMemoTransactionsById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}CreditMemo/PaymentByCredit?creditMemoId=${id}`
        );
    }
    getInvoiceReceivedPaymentById(id: Number, showVoided = false): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}ReceivedPayment/PaymentByInvoiceId?invoiceId=${id}&showVoided=${showVoided}`
        );
    }
    getSalesOrderReceivedPaymentById(id: Number, showVoided = false): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}ReceivedPayment/PaymentBySalesOrderId?salesOrderId=${id}&showVoided=${showVoided}`
        );
    }
    getReceivedPaymentsById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}ReceivedPayment/${id}`
        );
    }

    getReceivePaymentById(id: Number): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}ReceivedPayment/${id}`
        );
    }

    getAllGroups() {
        return this.http.get<any>(`${environment.inventoryURl}Group`);
    }

    getGroupById(groupId) {
        return this.http.get<any>(
            `${environment.inventoryURl}Type?groupId=${groupId}`
        );
    }

    // getAllTax() {
    //     return this.http.get<any>(`${environment.inventorySalesOrderUrl}Tax`);
    // }

    getAllTax() {
        return this.http.get<any>(
            `${environment.inventoryURl}Tax/TaxConfiguration`
        );
    }

    getAllUser() {
        return this.http.get<any>(`${environment.appOrgUrl}User`);
    }

    getWarehouseWiseProduct(typeId, pageNo, pageSize, searchValue, locationId,) {
        let params = new HttpParams();
        params = params.append("warehouseId", locationId);

        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !searchValue ? params : params.append("search", searchValue);
        return this.http
            .get<any>(
                `${environment.inventoryURl}Product/GetWarehouseWiseProduct?typeId=${typeId}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    updateStage(c, typeId, isBaseCurrency: boolean) {
        return this.http
            .put<any>(
                `${environment.inventorySalesUrl}SalesOrder/Stage?backOrderTypeId=${typeId}&isBaseCurrency=${isBaseCurrency}`,
                c
            )
            .toPromise()
            .then((res) => res);
    }

    getActivityLogs(id): Observable<any> {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}SalesOrder/${id}/ActivityLog`
        );
    }

    deleteSalesOrderComment(commentId): Observable<any> {
        return this.http.delete<any>(
            `${environment.coreUrl}ObjectStageAudit/${commentId}`
        );
    }

    updateSalesOrderComment(c) {
        return this.http
            .put<any>(`${environment.coreUrl}ObjectStageAudit`, c)
            .toPromise()
            .then((res) => res);
    }

    getAllProductChannel(name): Observable<any> {
        return this.http.get<any>(
            `${environment.configUrl}Configuration/Name?name=${name}`
        );
    }

    getAccountList() {
        return this.http.get<any>(
            `${environment.apiUrlAccount + "Account/"
            }AccountsWithName?channelId=0`
        );
    }

    getAccountsByChannelId(channelId, search) {
        const searchData = encodeURIComponent(search);
        return this.http.get<any>(
            `${environment.apiUrlAccount}Account/AccountsWithName?channelId=${channelId}&search=${searchData}`
        );
    }

    getAllAccountBySearch(
        pageSize: number,
        pageNumber: number,
        companyID: number,
        userLoginID: number,
        parentId = 0,
        dateSearch,
        columns,
        typeId,
        stageId?,
        searchValue?: string,
        seachFields?: string,
        options?,
        objectNamesList?
    ) {
        stageId = stageId ? stageId : 0;
        let url =
            environment.apiUrlAccount +
            "Account/" +
            "?organizationId=" +
            companyID +
            "&loginUserId=" +
            userLoginID +
            "&typeId=" +
            typeId +
            "&stageId=" +
            stageId +
            "&pageNumber=" +
            pageNumber +
            "&pageSize=" +
            pageSize +
            "&filter=" +
            dateSearch +
            "&isActive=" +
            true;
        const checkContactColumn = columns.find(
            (el) => el.field == "contactName"
        );
        if (checkContactColumn && checkContactColumn.show) {
            url = url + "&objectNameList=accountcontacts";
        }
        const checkPhonesColumn = columns.find((el) => el.field == "phone");
        if (checkPhonesColumn && checkPhonesColumn.show) {
            url = url + "&objectNameList=accountphones";
        }
        const checkAccountTypesColumn = columns.find(
            (el) => el.field == "accountTypesNames"
        );
        if (checkAccountTypesColumn && checkAccountTypesColumn.show) {
            url = url + "&objectNameList=accountTypes";
        }
        url =
            url +
            "&objectNameList=status&objectNameList=childaccounts&parentAccountId=" +
            parentId;
        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
        }
        if (
            dateSearch != "recentlyviewedcontacts" &&
            (!options || !options.sort)
        ) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        if (searchValue) {
            url = `${url}&SearchValue=${searchValue}&SearchColumns=${seachFields}`;
        }
        return this.http
            .get<any>(url, {
                observe: "response",
            })
            .toPromise()
            .then((res) => ({
                accounts: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllWarehouse2(pageNo, pageSize, isAscending) {
        let params = new HttpParams();
        params = !pageNo ? params : params.append("PageNumber", pageNo);
        params = !pageSize ? params : params.append("PageSize", pageSize);
        params = !isAscending
            ? params
            : params.append("IsAscending", isAscending);
        return this.http
            .get<any>(`${environment.inventoryURl}Warehouse`, {
                observe: "response",
                params,
            })
            .toPromise()
            .then((res) => ({
                wareHouses: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")),
            }));
    }

    getAllLocations(pageNo, pageSize, searchValue) {
        let params = new HttpParams();
        params = params.append("PageNumber", pageNo);
        params = params.append("PageSize", pageSize);
        params = params.append("SearchValue", searchValue);
        return this.http.get<any>(
            `${environment.inventoryURl}WareHouse/AllWarehouseDetails`,
            { params }
        );
    }

    getRMALocations() {
        return this.http.get<any>(`${environment.inventoryURl}WareHouse/ListRMAWarehouse`);
    }

    getAccountDetailsById(accountId: number) {
        return this.http
            .get<any>(
                `${environment.apiUrlAccount + "Account/AccountById/"
                }${accountId}`
            )
            .toPromise()
            .then((res) => res);
    }

    saveShippingFromAddress(obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/FromToAddress`,
            obj
        );
    }

    saveShippingToAddress(obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/FromToAddress`,
            obj
        );
    }

    saveShippingParcel(obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/Parcel`,
            obj
        );
    }

    saveShipment(obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/Shipment`,
            obj
        );
    }

    getShipmentInsurance(id, obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/Insurance`,
            obj
        );
    }

    createOrder(obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/Order`,
            obj
        );
    }

    createLabel(id, obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/${id}/Buy`,
            obj
        );
    }

    createFedexLabel(obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}FedEx/Shipment`,
            obj
        );
    }

    getFedexRates(id, objEncStr) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}FedEx/Rates?rateRequest=${objEncStr}&vendorID=${id}`,
            {}
        );
    }

    getShippingServices(data, vendorID) {
        return this.http.post<any>(`${environment.inventorySalesUrl}FedEx/ShippingServices?vendorID=${vendorID}`, data);
    }

    cancelFedexShipment(obj) {
        return this.http.put<any>(
            `${environment.inventorySalesUrl}FedEx/CancelShipment`,
            obj
        );
    }

    trackFedexShipment(obj, vendorId) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}FedEx/Track?trackRequest=${obj}&vendorID=${vendorId}`,
            {}
        );
    }

    createLabelForMultiplePackage(id, obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/Orders/${id}/Buy`,
            obj
        );
    }

    refundByShippingId(id) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/Refund/${id}`,
            {}
        );
    }

    getLabelPdf(url) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}EasyPost/LabelPdf?labelUrl=${url}`,
            {}
        );
    }

    downloadFedexLabel(url) {
        return this.http.get<any>(
            `${environment.inventorySalesUrl}FedEx/GetShipmentLabel?url=${url}`,
            {}
        );
    }

    getAllDiscount() {
        return this.http.get<any>(
            `${environment.inventoryURl}Discount/DiscountConfiguration`
        );
    }

    getAllVendors() {
        return this.http.get<any>(`${environment.vendorUrl}Vendor`);
    }

    getFedexAccounts(organizationId, vendorId) {
        return this.http.get<any>(
            `${environment.vendorUrl}FedEx/GetAccountsDetail?organisationID=${organizationId}&vendorID=${vendorId}`
        );
    }

    getAddressTypes() {
        return this.http.get<any>(`${environment.coreUrl}Address/AddressType`);
    }

    // Get Pricebook Discount Options
    getAllDiscountOption(groupName) {
        return this.http.get<any>(`${environment.inventoryURl}Type/GetAllTypeByGroupOrganization?groupName=${groupName}`);
    }

    getDiscounts(showShipping: boolean) {
        return this.http.get<any>(`${environment.inventoryURl}Discount?showShipping=${showShipping}`);
    }

    getAdditionalFees() {
        return this.http.get<any>(`${environment.inventoryURl}Discount/GetAllAdditionalFees`);
    }

    getUpsRates(id, data) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}UPS/Rates?vendorId=${id}`,
            data
        );
    }

    createUpsLabel(id, obj) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}UPS/Shipment?vendorId=${id}`,
            obj
        );
    }

    cancelUpsShipment(trackingNo, vendorId) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}UPS/CancelShipment?trackingNo=${trackingNo}&vendorId=${vendorId}`, {}
        );
    }

    getUpsShipmentLabel(obj, vendorId, trackingNo) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}UPS/GetShipmentLabel?vendorId=${vendorId}&trackingno=${trackingNo}`,
            obj
        );
    }

    trackUpsShipment(trackingNo, vendorId) {
        return this.http.post<any>(
            `${environment.inventorySalesUrl}UPS/Tracking?trackingNo=${trackingNo}&vendorId=${vendorId}`,
            {}
        );
    }

    getTaxByAddress(countryId: number, stateId?: number) {
        let params = new HttpParams();
        params = countryId ? params.append("countryId", countryId) : params;
        // params = stateId ? params.append("stateId", stateId): params;
        return this.http.get<any>(
            `${environment.inventoryURl}Tax/GetTaxByAddress`,
            { params }
        );
    }

    checkSerialNoInSystem(id, warehouseId, productId, module?) {
        let params = new HttpParams();
        params = module == 'salesOrder' ? params.append("salesorderId", id) :
            module == 'creditMemo' ? params.append("creditmemoId", id) :
                module == 'invoice' ? params.append("invoiceId", id) :
                    params;
        return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&warehouseId=${warehouseId}`, { params });
    }
    checkSerialNoInCustomerReturnSystem(warehouseId, productId, invoiceId, customerRMAid?) {
        let params = new HttpParams();
        params = !customerRMAid ? params.append('isReturn', true) : params;
        return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrders?productId=${productId}&invoiceId=${invoiceId}&warehouseId=${warehouseId}`, { params });
    }
    checkSystemTrackingDataForBill(pageNumber, pageSize, productId, warehouseId, invoiceId, searchValue, isReturn) {
        let params = new HttpParams();
        params = params.append('pageNumber', pageNumber);
        params = params.append('pageSize', pageSize);
        params = params.append('isReturn', isReturn);
        params = (!invoiceId ? params : params.append('invoiceId', invoiceId))
        params = params.append('productId', productId);
        params = params.append('warehouseId', warehouseId);
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        return this.http.get<any>(`${environment.inventoryURl}Product/SerialListForOrdersView`, { observe: 'response', params: params }).pipe(
            map((res: HttpResponse<any>) => {
                return {
                    tracking: res.body,
                    headers: JSON.parse(res.headers.get('x-pagination'))
                };
            })
        )
    }
    loadTrackingOptions(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}TrackingSetting`);
    }

    //#region Customer Rma

    getAllInvoicesByAccountId(accountId: number, warehouseId: number) {
        const invoiceListUrl = `${environment.inventorySalesUrl}Invoice/InvoiceListByAccount?accountId=${accountId}&warehouseId=${warehouseId}&isRMAList=true`;
        return this.http.get<any>(invoiceListUrl);
    }

    getAllInvoicesBySerialNumber(accountId: number, warehouseId: number, serialNumber: string) {
        const invoiceListUrl = `${environment.inventorySalesUrl}Invoice/InvoiceListBySerialNumber?accountId=${accountId}&warehouseId=${warehouseId}&serialNumber=${serialNumber}`;

        return this.http.get<any>(invoiceListUrl);
    }

    getSerialNumbers(accountId: any, warehouseId: any, serialNumber: any) {
        const serialNumbersUrl = `${environment.inventorySalesUrl}Invoice/SerialNumberList?accountId=${accountId}&warehouseId=${warehouseId}&serialNumber=${serialNumber}`;

        return this.http.get<any>(serialNumbersUrl);
    }

    getItemNumbers(accountId: any, warehouseId: any, itemNumber: any) {
        const itemNumbersUrl = `${environment.inventorySalesUrl}Invoice/ItemNumberList?accountId=${accountId}&warehouseId=${warehouseId}&itemNumber=${itemNumber}`;

        return this.http.get<any>(itemNumbersUrl);
    }

    getInvoiceOrderItemsByInvoiceId(accountId: number, invoiceId: number) {
        const invoiceOrderItemsUrl = `${environment.inventorySalesUrl}CustomerRma/GetAllInvoiceItemsByInvoiceId/${accountId}/${invoiceId}`;

        return this.http.get<any>(invoiceOrderItemsUrl);
    }

    getInvoiceOrderItemsBySerialNumber(accountId: number, warehouseId: number, serialNumber: String) {
        const invoiceOrderItemsUrl = `${environment.inventorySalesUrl}CustomerRma/GetAllInvoiceItemsBySerialNumber?accountId=${accountId}&warehouseId=${warehouseId}&serialNumber=${serialNumber}`;

        return this.http.get<any>(invoiceOrderItemsUrl);
    }

    getInvoiceOrderItemsByItemNumber(accountId: number, warehouseId: number, itemNumber: String) {
        const invoiceOrderItemsUrl = `${environment.inventorySalesUrl}CustomerRma/GetAllInvoiceItemsByItemNumber?accountId=${accountId}&warehouseId=${warehouseId}&itemNumber=${itemNumber}`;

        return this.http.get<any>(invoiceOrderItemsUrl);
    }

    getAllReturnTypes(): Observable<any> {
        return this.http.get<any>(`${environment.inventorySalesUrl}CustomerRma/GetAllReturnTypes`);
    }

    getAllReturnReasons(): Observable<any> {
        return this.http.get<any>(`${environment.inventorySalesUrl}CustomerRma/GetAllReturnReasons`);
    }

    getRmaStageChangeHistory(rmaId, objectId) {
        const updateRmaStageUrl = `${environment.inventorySalesUrl}CustomerRma/RmaStageHistory/${rmaId}?objectId=${objectId}`;
        return this.http.get<any>(updateRmaStageUrl);
    }

    updateRmaStage(rmaId, stageId, returnTypeId, reasonId, attachmentId, stageData, isCreateCredit): Promise<any> {
        const updateRmaStageUrl = `${environment.inventorySalesUrl}CustomerRma/UpdateStage/${rmaId}?stageId=${stageId}&returnTypeId=${returnTypeId}&reasonId=${reasonId}&attachmentId=${attachmentId}` +
            (isCreateCredit ? `&createCredit=${isCreateCredit}` : '');
        return this.http.put<any>(updateRmaStageUrl, stageData)
            .toPromise()
            .then((res) => res);
    }

    getCustomerReturnDetailsToConvert(id) {
        const customerReturnDetailsUrl = `${environment.inventorySalesUrl}CustomerRma/GetCustomerReturnDetailsToConvert/${id}`;
        return this.http.get<any>(customerReturnDetailsUrl);
    }

    rmaConverted(id) {
        const rmaConvertedUrl = `${environment.inventorySalesUrl}CustomerRma/RmaConverted/${id}`;
        return this.http.get<any>(rmaConvertedUrl);
    }
    fetchUnitOfMeasureCategories() {
        const url = `${environment.inventoryURl}Category/GetAllCategoryByGroupName?groupName=UnitOfMeasure`;
        return this.http.get<any>(url);
    }
    getAllLionoCoreGroups() {
        return this.http.get<any>(`${environment.coreUrl}Group`)
    }

    getAllSearchOptions(groupId) {
        return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`);
    }

    //#endregion

    /**Bulk Import**/
    bulkImportSerials(salesOrderId, invoiceId, creditId, warehouseId, data) {
        return this.http.post<any>(`${environment.inventorySalesUrl}Invoice/BulkImportSerial?invoiceId=${invoiceId}&salesOrderId=${salesOrderId}&creditMemoId=${creditId}&warehouseId=${warehouseId}`, data);
    }

    bulkScannederials(salesOrderId, invoiceId, creditId, warehouseId, data) {
        return this.http.post<any>(`${environment.inventorySalesUrl}Serial/BulkScanSerial?invoiceId=${invoiceId}&salesOrderId=${salesOrderId}&creditMemoId=${creditId}&warehouseId=${warehouseId}`, data);
    }


    checkSerialNoInAllSystem(serialNo, warehouseId, productId, cmId?): Observable<any> {
        let params = new HttpParams();
        params = cmId ? params.append('creditMemoId', cmId) : params;
        return this.http.get<any>(`${environment.inventorySalesUrl}Serial/CheckSerialAssociation?serial=${serialNo}&productIds=${productId}&warehouseId=${warehouseId}`, { params });
    }

    getAllCustomFields(id) {
        return this.http.get<any>(`${environment.configUrl}Configuration/CustomAttributes?objectId=${id}`);
    }

    getClosingStatement(year: number, month: number) {
        return this.http.get<any>(`${environment.financeURl}ClosingYear/ClosingYearLock?year=${year}&monthId=${month}`);
    }
}
